module.exports = __webpack_public_path__ + "img/picto-profil.efe236fa.svg";